export enum RemoveUserSteps {
    QUIT = 0,
    SELECT_USER = 1,
    REVIEW,
}
